import React, { useState,useEffect } from 'react';
import './RecorridoArtemisa.scss'
import View360 from '../View360/View360';

const RecorridoArtemisa = () => {
    const [idScene, setId] = useState("acceso");
    const [yaw, setyaw] = useState(50)
    const [pitch, setpitch] = useState(0)

    const handleImagen = (tipo) =>{
        const removeElement = document.getElementsByClassName("active");
        removeElement[0].classList.remove("active")
        const element = document.getElementById(tipo);
        element.classList.add("active");
        if(tipo==="alberca"){
            setId("alberca")
            setyaw(50)
            setpitch(0)
        }else{
            if(tipo==="acceso"){
                setyaw(-30)
                setpitch(0)
                setId("acceso")
            }
        }
    }
    return(
        <>
            <div className='contenedor_recorrido_artemisa'>
            {
                idScene ==="acceso" &&
                <View360 yaw={yaw} pitch={pitch} urlImagen="/assets/360/1.acceso.jpg" idScene="acceso"></View360>
            }
            {
                idScene ==="alberca" &&
                <View360 yaw={yaw} pitch={pitch} urlImagen="/assets/Artemisa/img-360-alberca-velasur.jpg" idScene="alberca"></View360>
            }
            <span className='disclamer'>Esta imagen es representativa del proyecto, sus características pueden cambiar sin previo aviso.</span>
            <div className='options artemisa'>
                <button id="acceso" className="active" onClick={()=>{handleImagen("acceso")}}>ACCESO</button>
                <button id="alberca" onClick={()=>{handleImagen("alberca")}}>ALBERCA</button>
            </div>
        </div>
        </>

    );
}
export default RecorridoArtemisa;